/* eslint-env browser */
import { isFunction } from 'lodash';
import page from 'page';
import pageExit from './page-exit';

const config = window.APP_CONFIG;

function pageVariant(...args) {
  const variantName = args.splice(0, 1)[0];
  const pageArgs = args.map(arg => {
    if (!isFunction(arg)) {
      return arg;
    }

    return (ctx, next) => {
      if (ctx.winningFullPageVariantName === variantName) {
        return arg.call(arg, ctx, next);
      }

      return next();
    };
  });

  page.apply(page, pageArgs);
}

pageVariant.exit = pageExit;

pageVariant.redirect = page.redirect;

function pageVariantStub(_, ...args) {
  return page.apply(page, args);
}

export default (config.disable_analytics ? pageVariantStub : pageVariant);



// WEBPACK FOOTER //
// ./src/modules/ab-page-js/page-variant.js